import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

import { Context } from '../../context/DataContext';
import CheckBoxField from '../../components/form/CheckBoxField';

import policyText from './privacy-policy';
import policyTextOther from './privacy-policy-other';

const AgreementConfirmationPage = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = React.useState(false);
  const {
    state: {
      loginInfo: { extWsClass },
    },
  } = React.useContext(Context);

  return (
    <Box sx={{ px: 2 }}>
      <Typography
        variant='h4'
        sx={{ my: 2 }}>
        同意書與延保須知
      </Typography>
      <Box>
        <Box
          component='div'
          dangerouslySetInnerHTML={{
            __html:
              extWsClass === 'LGB'
                ? policyText.replace(/\n/g, '<br/>')
                : policyTextOther.replace(/\n/g, '<br/>'),
          }}
          sx={{
            height: '300px',
            overflowY: 'auto',
            border: '1px solid black',
            borderRadius: 2,
            wordWrap: 'break-word',
            p: 2,
            boxShadow: '1px 1px 5px #555 inset',
            boxSize: 'border-box',
            textAlign: 'left',
            mb: 2,
          }}
        />
        <CheckBoxField
          fullWidth
          sx={{ mb: 2 }}
          labelStyle={{ fontSize: 12, textAlign: 'left' }}
          label='本人已清楚瞭解上開之個人資料同意書內容，並同意依個人資料保護法規定提供個人資料予立格科技股份有限公司上述個人資料使用事項。'
          value={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}>
          <Button
            color='secondary'
            variant='contained'
            sx={{ width: 128 }}
            onClick={() => {
              navigate('/dashboard');
            }}>
            不同意
          </Button>
          <Button
            variant='contained'
            sx={{ width: 128 }}
            disabled={!checked}
            onClick={() => {
              navigate('/extend-new/client-info');
            }}>
            下一步
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AgreementConfirmationPage;
